
define('text!modules/campaign/chart/templates/legendToggle.html',[],function () { return '<div class="btn-toggle">\n  <strand-icon type="event-marker" width="11" height="11"></strand-icon>\n  <span class="btn-txt">{{state}}</span>\n</div>\n';});

